module.exports = __webpack_public_path__ + "img/数据@2x.1237bb24.png";